import { SxProps, TextField } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import {
  Controller,
  FieldValues,
  useFormContext,
  ValidateResult,
} from "react-hook-form";
import { validateDateInput } from "../../../helpers/formatDateTime";

type Props = {
  name: string;
  label?: string;
  error?: boolean;
  sx?: SxProps;
  disableOpenPicker?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  minDate?: Date;
  maxDate?: Date;
  required: { value: boolean; message: string };
  validate?: (value: Date, fieldValues?: FieldValues) => ValidateResult;
  showHelperText?: boolean;
};

const DateField = ({
  name,
  label,
  error,
  sx = {},
  disableOpenPicker = false,
  disabled = false,
  readOnly = false,
  minDate,
  maxDate,
  required = { value: false, message: "" },
  validate,
  showHelperText = true,
}: Props) => {
  const { control } = useFormContext();

  const rules = {
    ...(required && { required }),
    validate: (value: Date, fieldValues: FieldValues) =>
      validate && typeof validate === "function"
        ? validate(value, fieldValues)
        : validateDateInput(value),
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <DesktopDatePicker
          {...field}
          label={label}
          onChange={(value: Date | null) => {
            field.onChange(value);
          }}
          disabled={disabled}
          readOnly={readOnly}
          disableOpenPicker={disableOpenPicker}
          minDate={minDate}
          maxDate={maxDate}
          format="dd.MM.yyyy"
          slots={{ textField: TextField }}
          slotProps={{
            textField: {
              onBlur: field.onBlur,
              error: error || !!fieldState.error,
              helperText: showHelperText
                ? fieldState.error?.message
                : undefined,
              size: "small",
              fullWidth: true,
              sx: { ...sx },
            },
          }}
        />
      )}
    />
  );
};

export default DateField;
